const Events = require('PSEvents');
const State = require('PSState');
const i18 = require('i18n');


cc.Class({
    extends: cc.Component,

    properties: {
        container: cc.Node,
        symbolLabel: cc.Label,
    },

    onLoad () {
        this.container = this.container || this.node;
        this.items = [];
        const configData = State.gameConfiguration;

        if (configData) {
            this.init(configData);
        } else {
            Events.subscribe(Events.COMMON_INITIALIZED, ({ gameConfiguration }) => {
                this.init(gameConfiguration);
            });
        }

    },

    init ({ pricelist, paylines, scaler }) {
        this.betAmount = State.betAmount;
        this.pricelist = pricelist;

        if (scaler) {
            this.prizeCoefficient = 1 / scaler;
        } else if (paylines && paylines.length) {
            this.prizeCoefficient = 1 / paylines.length;
        } else {
            this.prizeCoefficient = 1;
        }
        this._instantiateList();
        this._updatePriceList();
        Events.subscribe(Events.BET_CHANGED, ({ betAmount }) => {
            if (this.betAmount !== betAmount) {
                this.betAmount = betAmount;
                this._updatePriceList();
            }
        });
    },

    _instantiateList () {
        const deltaY = 50;

        this.pricelist.forEach((itemData, index) => {

            const item = cc.instantiate(this.symbolLabel.node);
            // eslint-disable-next-line no-underscore-dangle
            item._components[0].string =  i18.formatCurrency(itemData *this.betAmount);
            this.container.addChild(item);
            item.setPosition(0, - index - deltaY);

            this.items.push(item);
        });
    },

    _updatePriceList () {
        this.pricelist.forEach((price, index) => {

            // eslint-disable-next-line no-underscore-dangle
            this.items[index]._components[0].string = i18.formatCurrency(price * this.betAmount);
        })


    },

});
